


























import QErrors from "@/common/qErrors.vue";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qInput",
  components: { QErrors },
})
export default class qInput extends Vue {
  @PropSync("value", {
    type: String,
  })
  public valueSync;

  @Prop({
    default: false,
  })
  public required;

  @Prop({
    type: String,
    default: "text",
  })
  public type;

  @Prop({
    type: String,
    required: true,
  })
  public name;

  @Prop({
    type: String,
    default: "",
  })
  public placeholder;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public errors;

  public clearError() {
    this.$emit("update:errors", { ...this.errors, ...{ [this.name]: [] } });
  }
}
